import React from "react";
import { NavLink } from "react-router-dom";
import {
    AccordionItem,
    AccordionItemPanel,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemState,
} from "react-accessible-accordion";
const inventarios_almacen = require("assets/img/icons/inventario.png");
const inventarios_almacen_activo = require("assets/img/icons/inventario_activo.png");

export const InventariosAlmacenItem = ({
    permisos,
    proveedor,
    proveedor_admin,
    location,
    moduloId,
    isItemSelected,
}) => {
    if (!permisos) return null;
    if (
        !permisos.inventarios_historico &&
        !permisos.inventarios_reporte &&
        !permisos.inventarios_consulta_otros_acopios
    )
        return null;
    if (proveedor === true || proveedor_admin === true) return null;

    return (
        <div className="nav-item">
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <AccordionItemState>
                            {({ expanded }) => {
                                const isSelected = isItemSelected(
                                    moduloId,
                                    location.hash,
                                    expanded,
                                );
                                return (
                                    <div
                                        className={`nav-link ${isSelected ? "active" : ""}`}
                                    >
                                        <img
                                            src={
                                                isSelected
                                                    ? inventarios_almacen_activo
                                                    : inventarios_almacen
                                            }
                                            className="icon-menu"
                                            alt=""
                                        />
                                        INVENTARIOS ALMACÉN
                                    </div>
                                );
                            }}
                        </AccordionItemState>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemState>
                    {({ expanded }) => {
                        const isSelected = isItemSelected(
                            moduloId,
                            location.hash,
                            expanded,
                        );
                        return (
                            isSelected && (
                                <AccordionItemPanel
                                    className={
                                        isSelected ? "acordion-expanded" : ""
                                    }
                                >
                                    <div className="pb-2">
                                        {permisos.inventarios_historico &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/inventarios-almacen/historico"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/inventarios-almacen/historico",
                                                            ) ||
                                                            location.pathname.includes(
                                                                "/inventarios-almacen/almacenes",
                                                            ) ||
                                                            location.pathname.includes(
                                                                "/inventarios-almacen/gestion-almacen",
                                                            ) ||
                                                            location.pathname.includes(
                                                                "/inventarios-almacen/ingresos-almacen",
                                                            )
                                                        }
                                                    >
                                                        HISTÓRICO
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.inventarios_historico &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/inventarios-almacen/inventario-inicial"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/inventarios-almacen/inventario-inicial",
                                                            )
                                                        }
                                                    >
                                                        INVENTARIO INICIAL
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.inventarios_consulta_otros_acopios &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/inventarios-almacen/otros-acopios"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/inventarios-almacen/otros-acopios",
                                                            )
                                                        }
                                                    >
                                                        OTROS ACOPIOS
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.inventarios_reporte &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/inventarios-almacen/reporte"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/inventarios-almacen/reporte",
                                                            )
                                                        }
                                                    >
                                                        REPORTES
                                                    </NavLink>
                                                </div>
                                            )}
                                    </div>
                                </AccordionItemPanel>
                            )
                        );
                    }}
                </AccordionItemState>
            </AccordionItem>
        </div>
    );
};
